<template>
  <layout :title="$t('advertising.title')" :sub-title="$test.fullLabel">
    <template v-if="!$helper.isPlayerDemo12" slot="right-column">
      <div class="w-25 h-100">
        <div :style="`background-image: url(${$helper.getImage($test.image.upload_file_path)})`" class="h-100 test-image" />
      </div>
    </template>
    <template slot="container">
      <div class="layout-content">
        <loader-text v-if="isLoading" :title="$t('advertising.is_loading')" />
        <template v-else>
          <div class="h-100">
            <b-container class="mt-2 mb-2 h-100 d-flex align-items-center">
              <b-carousel
                v-if="!_.isEmpty(advertisings)"
                id="carouselAdvertising"
                ref="carouselAdvertising"
                :interval="4000"
                controls
                indicators
                data-pause="false"
              >
                <b-carousel-slide
                  v-for="ad in advertisings"
                  :key="ad.id"
                  :caption="ad.label"
                  :text="ad.content"
                  :img-src="$helper.getImage(ad.image.upload_file_path)"
                  img-width="1024"
                  img-height="480"
                  class="h-100"
                />
              </b-carousel>
              <div v-else>
                <img class="img-fluid" :alt="$t('title')" src="/static/img/pub_pcie.png">
              </div>
            </b-container>
          </div>
        </template>
      </div>
      <div class="layout-footer border-top w-100">
        <div class="d-flex justify-content-between align-items-center h-100 ml-auto">
          <b-button
            :to="{ name: 'logout' }"
            variant="light"
            class="w-25 h-100 d-flex justify-content-center align-items-center"
            block
          >
            {{ $t('actions.quit_test') }}
          </b-button>
          <div class="w-25 h-100">
            <template v-if="testIsReady">
              <form v-loading="`<i class='ti ti-refresh ti-spin'></i>`" class="h-100" @submit.prevent="onStartTestSubmit()">
                <b-button
                  variant="primary"
                  class="h-100 text-uppercase p-2"
                  block
                  type="submit"
                >
                  {{ $t('actions.start_test') }}
                </b-button>
              </form>
            </template>
            <div v-else class="loader m-auto h-100 justify-content-end pr-4">
              <progress-circle :percent="percentageLoaded" :fill="{ color: '#0094de' }" />
              <h1>{{ percentageLoaded }}%</h1>
            </div>
          </div>
        </div>
      </div>
    </template>
  </layout>
</template>

<script>
  import Layout from '@/views/Layout';
  import LoaderText from '@/components/loader-text';
  import ProgressCircle from '@/components/progress-circle';
  import LoadOnNavigate from '@/mixins/load-on-navigate';

  export default {
    name: 'Advertising',
    components: {
      Layout,
      LoaderText,
      ProgressCircle,
    },
    mixins: [
      LoadOnNavigate,
    ],
    data() {
      return {
        isLoading: true,
        advertisings: null,
        // sliding: null,
        imagesIsReady: false,
        timerIsReady: false,
        countImgLoaded: 0,
        countSecLoaded: 0,
        waitingTime: this.$env.dev ? 1 : 15,
        slickOptions: {
          slidesToShow: 3,
        },
      };
    },
    computed: {
      testImg() {
        return this.$test.images || [];
      },
      nbImg() {
        return this.testImg.length || Object.keys(this.testImg).length;
      },
      percentageLoaded() {
        if (this._.isUndefined(this.$test.images)) {
          return 0;
        }

        // Img = x/75 || Timer = x/25
        const percentageImg = Math.floor(75 * (this.nbImg === 0 || this.countImgLoaded / this.nbImg));
        const percentageTime = Math.floor(this.countSecLoaded * 25 / this.waitingTime);
        return Math.min(100, percentageImg + percentageTime);
      },
      testIsReady() {
        return this.timerIsReady && this.imagesIsReady;
      },
    },
    methods: {
      async load() {
        this.isLoading = true;
        Promise.all([
          this.getAdvertising(),
          this.getCacheTestImg(),
          this.waitOneSec(),
        ]).then(() => {
          this.isLoading = false;
        });
      },
      async getAdvertising() {
        const advertising = await this.$test.getAdvertising();
        this.$set(this, 'advertisings', advertising);
      },
      async getCacheTestImg() {
        await this.$test.getImages();
        this.loadImgs();
      },
      next() {
        this.$refs.slick.next();
      },
      prev() {
        this.$refs.slick.prev();
      },
      reInit() {
        // Helpful if you have to deal with v-for to update dynamic lists
        this.$nextTick(this.$refs.slick.reSlick);
      },
      waitOneSec() {
        if (this.countSecLoaded < this.waitingTime) {
          this.countSecLoaded += 1;
          setTimeout(this.waitOneSec, 1000);
        } else {
          this.timerIsReady = true;
        }
      },
      loadImgs() {
        if (this._.isEmpty(this.testImg)) {
          this.imagesIsReady = true;
        }
        this._.map(this.testImg, img => this.$helper.getImage(img.upload_file_path)).forEach((src) => {
          const img = new Image();
          img.addEventListener('load', this.imgLoaded);
          img.addEventListener('error', this.imgError);
          img.src = src;
        });
      },
      imgLoaded() {
        this.countImgLoaded += 1;
        if (this.countImgLoaded >= this.nbImg) {
          this.imagesIsReady = true;
        }
      },
      imgError() {
        // TODO handle error;
        this.imgLoaded();
      },
      // onSlideStart() {
      //   this.sliding = true;
      // },
      // onSlideEnd() {
      //   this.sliding = false;
      // },
      onStartTestSubmit() {
        return this.$test.startTest().then(() => {
          this.$router.push({ name: 'test' });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  .loader {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 20px;
    h1 {
      margin-left: 20px;
    }
  }

  .loaded {
    h1 {
      margin-left: 20px;
      cursor: pointer;
    }
  }

  .test-image {
    background: {
      size: contain;
      position: center;
      repeat: no-repeat;
    }
  }

  /deep/ .carousel {
    width: 100%;
    max-height: 100%;

    .carousel-inner {
      height: 100%;
    }
  }

  /deep/ .advertising-slide {
    height: 100px;
    background: {
      size: contain;
      repeat: no-repeat;
      position: center;
    }
  }
</style>
